import { FC, PropsWithChildren } from 'react';

type DeleteModalInputHintProps = PropsWithChildren;

export const DeleteModalInputHint: FC<DeleteModalInputHintProps> = ({ children }) => {
  return <p className='text-sm font-medium text-secondary-700'>{children}</p>;
};
